import request from '../utils/request';
export function fetchClinicUsers(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    const role = filters?.role;
    const isActive = filters?.is_active;
    const user = filters?.user;
    const isDefault = filters?.is_default;
    if (search) {
        params.append('search', search);
    }
    if (role) {
        params.append('role', role);
    }
    if (isActive !== undefined) {
        params.append('is_active', String(isActive));
    }
    if (user) {
        params.append('user', user);
    }
    if (isDefault !== undefined) {
        params.append('is_default', String(isDefault));
    }
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/clinic-users/?${queryString}`
        : '/api/v1/admin/clinic-users/';
    return request()
        .get(url)
        .send();
}
/**
 * Find the ClinicUser row (if any) that is currently the given user's default clinic,
 * excluding a specific row (e.g. the one being edited, so it doesn't "find itself").
 * Used to warn an admin before an action would demote a user's existing default.
 */
export async function findUsersCurrentDefaultClinicUser(userId, excludeClinicUserId) {
    const response = await fetchClinicUsers({ user: userId, is_default: true });
    const data = response.body;
    const rows = Array.isArray(data) ? data : data.results || [];
    const match = rows.find((row) => row.id !== excludeClinicUserId);
    return match ? { id: match.id, clinic: match.clinic } : null;
}
export function deleteClinicUser(id) {
    return request()
        .delete(`/api/v1/admin/clinic-users/${id}/`)
        .send();
}
export function updateClinicUser(id, payload) {
    return request()
        .patch(`/api/v1/admin/clinic-users/${id}/`)
        .send(payload);
}
export function createClinicUser(payload) {
    return request()
        .post('/api/v1/admin/clinic-users/')
        .send(payload);
}
export function fetchClinicUserFormUsers() {
    return request()
        .get('/api/v1/users/')
        .send();
}
export function fetchClinicUserFormClinics() {
    return request()
        .get('/api/v1/clinics/')
        .send();
}
